import axios from "axios";
import config from "../Config.json";

const LoginUser = async (data) => {
    try {       
        const response = await axios.post(`${config.API_URL}/app/login`, data)
        return response
    } catch (error) {
        return error
    }
}

export default LoginUser;